import { render, staticRenderFns } from "./BackSection.vue?vue&type=template&id=4f90032a&scoped=true"
import script from "./BackSection.vue?vue&type=script&lang=js"
export * from "./BackSection.vue?vue&type=script&lang=js"
import style0 from "./BackSection.vue?vue&type=style&index=0&id=4f90032a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f90032a",
  null
  
)

export default component.exports